import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';

import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { IMaskModule } from 'angular-imask';
import { ToastrModule } from 'ngx-toastr';
import { LsnNumpadModule } from '../lsn-numpad/numpad.module';
import { DialogComponent } from './components/dialog/dialog.component';
import { SpinnerHostComponent } from './components/spinner-host/spinner-host.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { DebounceDirective } from './directive/debounce.directive';
import { SpinnerContentDirective } from './directive/spinner.directive';
import { CheckboxComponent } from './middleware/checkbox/checkbox.component';
import { DatepickerComponent } from './middleware/datepicker/datepicker.component';
import { ErrorsComponent } from './middleware/errors/errors.component';
import { InputMaskComponent } from './middleware/input-mask/input-mask.component';
import { InputComponent } from './middleware/input/input.component';
import { NumericComponent } from './middleware/numeric/numeric.component';
import { NumPadComponent } from './middleware/numpad/numpad.component';
import { OutputComponent } from './middleware/output/output.component';
import { SelectComponent } from './middleware/select/select.component';
import { FlexFilterPipe } from './pipe/flex-filter.pipe';
import { JoinDescriptionsPipe } from './pipe/join-descriptions.pipe';
import { LsnDatePipe } from './pipe/lsn-date.pipe';
import { OnlyEstimatePipe } from './pipe/only-estimate.pipe';
import { PageNumberPipe } from './pipe/page-number.pipe';
import { PremiumPipe } from './pipe/premium.pipe';
import { RoleLabelPipe } from './pipe/role-label.pipe';
import { SuffixLabelPipe } from './pipe/suffix-label.pipe';
import { YesNoPipe } from './pipe/yes-no.pipe';
import { LsnNumericModule } from '../lsn-numeric/numeric.module';

@NgModule({
    declarations: [
        InputComponent,
        OutputComponent,
        DialogComponent,
        ErrorsComponent,
        SelectComponent,
        InputMaskComponent,
        DatepickerComponent,
        NumericComponent,
        NumPadComponent,
        CheckboxComponent,
        DebounceDirective,
        PremiumPipe,
        LsnDatePipe,
        SuffixLabelPipe,
        RoleLabelPipe,
        PageNumberPipe,
        FlexFilterPipe,
        JoinDescriptionsPipe,
        YesNoPipe,
        OnlyEstimatePipe,
        SpinnerContentDirective,
        SpinnerHostComponent,
        SpinnerComponent,
    ],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatTableModule,
        MatCheckboxModule,
        MatRadioModule,
        MatDatepickerModule,
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        MatTabsModule,
        MatDialogModule,
        MatSidenavModule,
        MatListModule,
        MatProgressSpinnerModule,
        OverlayModule,
        MatMenuModule,
        MatListModule,
        MatExpansionModule,
        MatTooltipModule,
        MatNativeDateModule,
        TranslateModule.forChild(),
        ToastrModule.forRoot(),
        FormsModule,
        HttpClientModule,
        IMaskModule,
        LsnNumpadModule,
        LsnNumericModule.forRoot({
            default: {
                precision: 0,
                thousands: ' ',
                decimals: ','
            }
        }),
    ],
    exports: [
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatTableModule,
        MatCheckboxModule,
        MatRadioModule,
        MatDatepickerModule,
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        MatTabsModule,
        MatDialogModule,
        MatSidenavModule,
        MatListModule,
        MatProgressSpinnerModule,
        OverlayModule,
        MatMenuModule,
        MatListModule,
        MatExpansionModule,
        MatTooltipModule,
        MatNativeDateModule,
        HttpClientModule,
        IMaskModule,
        InputComponent,
        OutputComponent,
        DialogComponent,
        ErrorsComponent,
        SelectComponent,
        InputMaskComponent,
        DatepickerComponent,
        NumericComponent,
        NumPadComponent,
        CheckboxComponent,
        DebounceDirective,
        LsnNumpadModule,
        LsnNumericModule,
        PremiumPipe,
        LsnDatePipe,
        SuffixLabelPipe,
        RoleLabelPipe,
        PageNumberPipe,
        FlexFilterPipe,
        JoinDescriptionsPipe,
        YesNoPipe,
        OnlyEstimatePipe,
        SpinnerContentDirective,
        SpinnerHostComponent,
        SpinnerComponent,
    ],
    entryComponents: [
        DialogComponent
    ],
    providers: [
        SuffixLabelPipe,
        FlexFilterPipe,
        JoinDescriptionsPipe,
    ]
})
export class SharedModule {
}
